<template>
  <div class="col-12 mt-4">
    <DottedLineHeader :text="$t('more.arithmies')"/>

    <div class="row" style="align-items: center; text-align: center;">
      <div class="col-md-6">
        <RadioButtonGroup v-if="!printing" name="arithmies-stats-filter" :items="timeRangeLabels" :values="timeRangeKeys" @valueChanged="filterValueChanged" style="display: block;"/>
        <span v-if="printing" class="mb-3" style="display: block;">{{$t("more.selected_time_range")}} <span class="selected-time-range">{{$t(timeRangeLabels[timeRangeKeys.indexOf(selectedTimeRange)])}}</span></span>
        <BarChart v-if="!printing || !chartImage" id="arithmystats-chart" ref="barchart" :chartData="data" :labels="chartLabels" :width="600" :height="400"/>
        <img v-if="printing && chartImage" :src="chartImage" style="height: 200px; width: 300px;"/>
      </div>
      <div class="col-md-6">
        <table class="arithmies-stats-table">
          <thead>
            <tr>
              <th></th>
              <th class="table-vtitle" v-for="label in timeRangeLabels" :key="'thead-' + label">{{$t(label)}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(key, index) in arithmyKeys" :key="'tkey-' + index">
              <td class="table-htitle">{{$t(arithmyLabels[index])}}</td>
              <td v-for="time in timeRangeKeys" :key="'ttime-' + time">{{sharedTest && sharedTest.stats.arithmies[time][key]}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import DottedLineHeader from '@/components/DottedLineHeader.vue'
import BarChart from '@/components/BarChart.js'
import RadioButtonGroup from '@/components/RadioButtonGroup.vue'
export default {
  components: {
    DottedLineHeader,
    RadioButtonGroup,
    BarChart
  },
  props: {
    sharedTest: Object,
    printing: Boolean
  },
  watch: {
    printing (to, from) {
      if (to) {
        this.chartImage = this.$refs.barchart.export2image()
      } else {
        this.chartImage = null
      }
    },
    sharedTest () {
      this.filterValueChanged('today')
    }
  },
  methods: {
    filterValueChanged: function (time) {
      this.selectedTimeRange = time
      if (!this.sharedTest) {
        return
      }
      this.data = []
      this.arithmyKeys.forEach((key, index, array) => {
        this.data.push(this.sharedTest.stats.arithmies[time][key])
      })
    }
  },
  computed: {
  },
  data: () => ({
    chartImage: null,
    chartLabels: [],
    selectedTimeRange: 'today',
    arithmyKeys: [
      'tachycardia',
      'bradycardia',
      'afib',
      'normal'
    ],
    arithmyLabels: [
      'more.tachycardia',
      'more.bradycardia',
      'more.afib',
      'more.normal'
    ],
    timeRangeKeys: [
      'today',
      'last7',
      'last30',
      'last90'
    ],
    timeRangeLabels: [
      'filter.today',
      'filter.last7',
      'filter.last30',
      'filter.last90'
    ],
    data: null
  }),
  mounted () {
    var that = this
    this.chartLabels = []
    this.arithmyLabels.forEach(function (value) {
      that.chartLabels.push(that.$t(value))
    })

    this.filterValueChanged('today')
  }
}
</script>

<style>
table.arithmies-stats-table {
  width: 90%;
  font-size: small;
  margin: 0 20px 0;
}

table.arithmies-stats-table td, table.arithmies-stats-table th {
  text-align: center !important;
}
tr td:first-child {
  text-align: start !important;
}

table.arithmies-stats-table th {
  color: gray;
  font-weight: normal;
}

#arithmystats-chart {
  height: 200px;
  width: 300px;
  position: relative;
  margin: 0 auto;
}

#arithmystats-chart canvas {
  width: 300px !important;
  height: 200px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/ArithmiesStats.vue